<template>
  <Modal :value="value" :mask-closable="false" title="制作同款" @on-cancel="closeModel">
    <template v-if="isAdd">
      <Form ref="formData" :model="formData" :rules="ruleValidate" :label-width="110" label-position="left">
        <FormItem label="姓名" prop="userName">
          <Input :disabled="isDisabled" v-model="formData.userName"></Input>
        </FormItem>
        <FormItem label="手机号" prop="phone">
          <Input disabled v-model="formData.phone"></Input>
        </FormItem>
        <FormItem label="公司" prop="company">
          <Input :disabled="true" v-model="formData.company"></Input>
        </FormItem>
        <FormItem label="公司地址" prop="city">
          <Input :disabled="true" v-model="formData.city"></Input>
        </FormItem>
        <FormItem label="需求简述" prop="description">
          <Input v-model="formData.description" type="textarea" :autosize="{ minRows: 8, maxRows: 10 }" :maxlength="500"></Input>
        </FormItem>
        <FormItem label="附件上传" prop="filePath">
          <Upload
            action="/docking/api/oss/upload"
            :headers="{ 'Authorization': `Bearer ${token}` }"
            :max-size="512000"
            :before-upload="beforeUpload"
            :on-exceeded-size="onExceededSize"
            :on-success="onSuccess"
            :on-error="onError"
            :on-remove="onRemove"
            accept=".zip,.rar,.7z"
            :default-file-list="uploadFileList"
          >
            <div style="display: flex; align-items: center;">
              <Button icon="ios-cloud-upload-outline" type="primary">上传</Button>
              <p style="font-size: 12px; margin-left: 20px;">注：将所需文件压缩成压缩包上传</p>
            </div>
          </Upload>
        </FormItem>
        <FormItem>
          <a @click="openDetail">查看需求规格提交规范</a>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="closeModel" :disabled="btnLoading">关闭</Button>
        <Button type="primary" @click="confirmModel" :loading="btnLoading">提交</Button>
      </div>
    </template>
    <template v-if="!isAdd">
      <Form :model="formData" :label-width="110">
        <FormItem label="姓名">{{ formData.userName }}</FormItem>
        <FormItem label="手机号">{{ formData.phone }}</FormItem>
        <FormItem label="公司">{{ formData.company }}</FormItem>
        <FormItem label="公司地址">{{ formData.city }}</FormItem>
        <FormItem label="需求简述">{{ formData.description }}</FormItem>
        <FormItem label="附件下载" v-if="formData.filePath">
          <Button shape="circle" icon="md-download" :to="formData.filePath">附件下载</Button>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="closeModel">关闭</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { handleLocalStorage } from "@/utils/handleLocalStorage.js"
import { mapState } from 'vuex'
// 表单初始值
const initFormData = () => {
  return {
    id: null,
    userId: '', // 已登录必传
    userName: '', // 姓名 - 未登录必传
    phone: '', // 手机号
    smsCode: '',
    description: '', // 需求简述
    company: '', // 公司
    city: '', // 公司地址
    filePath: '' // 附件地址
  };
}
export default {
  name: 'ModelMakeSame',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // 如果有(模型)id则认为是获取需求详情
    modelId: {
      type: String,
      default: ''
    },
    // 如果有详情，则认为是编辑
    detail: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      btnLoading: false,
      formData: {},
      ruleValidate: {
        userName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { 
            pattern: /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(166)|(17([2-3]|[5-8]))|(18[0-9])|(19[1|3])|(19([8-9])))\d{8}$/,
            message: '手机号码格式不正确',
            trigger: 'blur'
          }
        ],
        company: [
          { required: true, message: '请输入公司', trigger: 'blur' }
        ],
        city: [
          { required: true, message: '请输入公司地址', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入需求描述', trigger: 'blur' }
        ],
        filePath: [
          { required: true, message: '请上传附件', trigger: 'change' }
        ]
      }
    }
  },
  computed: {    
    token() {
      return handleLocalStorage.getTokenItem()
    },
    isAdd() {
      return !this.modelId
    },
    isDisabled() {
      return this.formData.id
    },
    uploadFileList() {
      if(this.formData.filePath) {
        let url = this.formData.filePath
        let index = url.lastIndexOf('/') + 1
        return [
          { name: url.substring(index), url: this.formData.filePath }
        ]
      } else {
        return []
      }
    },
    ...mapState('user', ['userInfo']),
  },
  watch: {
    value(val) {
      if(!val) return
      if(this.modelId) {
        this.getApplyDetail()
      } else if(Object.keys(this.detail).length) {
        // 编辑
        for(let key in this.detail) {
          this.formData[key] = this.detail[key]
        }
      }
    }
  },
  created() {
    this.resetData()
  },
  methods: {
    // 获取需求详情
    getApplyDetail() {
      this.$http(`/api/modelApply/getModelApply/${this.modelId}`)
        .then(res => {
          if (res.data.status !== 200) {
            return this.$Message.error(res.data.msg);
          }
          this.formData = res.data.data
        })
    },
    beforeUpload() {
      if(this.formData.filePath) {
        this.$Message.error('最多只能上传一个文件，建议将多文件整理成一个压缩包文件上传')
        return false
      }
    },
    // 文件上传成功回调
    onSuccess(response, file, fileList) {
      let { data } = response
      this.formData.filePath = data
      this.$refs['formData'].validateField('filePath')
    },
    // 文件移除回调
    onRemove() {
      this.formData.filePath = ''
    },
    // 文件超出指定大小限制时的回调
    onExceededSize() {
      this.$Message.error('附件文件上传大小最大不能超过500M')
    },
    // 文件上传失败的回调
    onError() {
      this.$Message.error('服务异常，文件上传失败')
    },
    confirmModel() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          // 如果传递过来的表单数据id有值，则认为是编辑
          if(this.formData.id) {
            this.requestAction('/api/modelApply/edit')
          } else {
            this.requestAction('/api/modelApply/save')
          }
        }
      })
    },
    requestAction(url) {
      this.$http(url, this.formData, 'POST')
        .then(res => {
          if (res.data.status === 200) {
            this.closeModel()
            this.$emit('refresh')
            this.$Message.success('操作成功，您的专属商务正火速赶来与您沟通，请耐心等待');
          } else {
            this.$Message.error('提交失败');
          }
        })
        .finally(() => {
          this.btnLoading = false
        })
    },
    openDetail() {
      this.$Modal.info({
        title: '需要上传的资源',
        content: `
          <p>1. 全景图</p>
          <p>2. 3DMAX模型</p>
          <hr style="margin: 10px 0;" />
          <p>全景图要求：</p>
          <p>(1) 相机：自由相机，高度大概1.45米左右，建议按照参观路线每隔3米内一个点位，相机方向按照路线的方向，相机越靠近空间文字越清晰。 相机和全景图名字要对应，命名“C”开头（例如：C001）</p>
          <p>(2) 全景图比例：宽高2：1（如9000：4500）</p>
          <p>(3) 模型要求：尽量能不要的面就不要，相机保留在模型里面</p>
        `,
        okText: '知道了'
      })
    },
    closeModel() {
      this.$emit('input', false)
      this.resetData()
    },
    // 重置表单数据
    resetData() {
      this.$refs['formData'] && this.$refs['formData'].resetFields();
      let formData = initFormData()
      let { userName, userPhoneNumber, userCompany, userId, companyAddress } = this.userInfo
      formData.userName = userName || ''
      formData.phone = userPhoneNumber || ''
      formData.company = userCompany || ''
      formData.city = companyAddress || ''
      formData.userId = userId || ''
      this.formData = formData
    }
  }
}
</script>